import { Component, OnInit } from '@angular/core';
import { VillageService } from 'src/app/services/village.service';
import {ThemePalette} from '@angular/material/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { MainGatesComponent } from '../main-gates/main-gates.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-village-config',
  templateUrl: './add-village-config.component.html',
  styleUrls: ['./add-village-config.component.css']
})

export class AddVillageConfigComponent implements OnInit {
  village_list:any
  color: ThemePalette = "primary";
  checked = false;
  Village_form :FormGroup | any;
  constructor(private villageSer : VillageService , 
     public dialogRef: MatDialogRef<MainGatesComponent>,){}

  ngOnInit(){
    this.allVillage()
    this.initForm()
  }
  initForm(){
    this.Village_form = new FormGroup({
      villages: new FormControl("", [Validators.required]),
      rented_unit: new FormControl(""),
      kids_access: new FormControl(""),
    })
  }

  allVillage(){
    this.villageSer.villageList().subscribe((res:any) => {
      console.log(res)
      this.village_list = res
    })
  }
  add_village_config(){
    let data = this.Village_form.value
    console.log(data)
     this.dialogRef.close(data)
  }
}
